<div class="d-flex flex-row mb-2 align-top" *ngIf="indicator">
  <div class="checkbox" [class.enabled]="canToggle">
    <ng-container *ngIf="isLoading; else giCheckBoxTemplate">
      <div class="spinner-border spinner-border-sm color-neutral" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </ng-container>
    <ng-template #giCheckBoxTemplate>
      <ng-container *ngIf="isChecked">
        <ng-container
          *ngIf="assessment && assessorProfile; else noAssessorData">
          <i
            [disableTooltip]="!assessment || !assessorProfile"
            ngbTooltip="Assessed by {{
              assessorProfile.profile | fullNameFromProfile
            }} on {{ assessment.createdAt | formatDate }}"
            container="body"
            class="bi bi-check2-circle active"
            (click)="openUncheckConfirmModal()"></i>
        </ng-container>
        <ng-template #noAssessorData>
          <i
            class="bi bi-check2-circle active"
            (click)="openUncheckConfirmModal()"></i>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="!isChecked">
        <i class="bi bi-circle color-dark-gray" (click)="toggleGI()"></i>
      </ng-container>
    </ng-template>
  </div>
  <div [innerHTML]="indicator.content" class="content"></div>
</div>
<app-uncheck-confirm-modal #uncheckConfirmModal (confirmRemove)="toggleGI()" />
